import {Localized} from "@fluent/react"
import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Paper} from "@mui/material"
import { UrsOfferRequirement } from "./ursOfferSlice"
import { Attachements } from "../urs/Attachements"
import { BlobResourceType } from "../documents/blobResourceTypes"


interface OfferAttachementsDialogProps {
    onClose       : () => void
    canUpload     : boolean
    canDelete     : boolean
    requirement   : UrsOfferRequirement | null
    /** GUID of the owning URS document (the offer's company-bearing parent). */
    ursGuid       : string
}

export const OfferAttachementsDialog = ({ requirement, onClose, canUpload, canDelete, ursGuid} : OfferAttachementsDialogProps) => {
   
    if (requirement === null) return <div></div>

   return <Dialog open={true} fullWidth maxWidth="md">
        <DialogTitle>
            <Localized id="attachements">Załączniki</Localized>
        </DialogTitle>
        <DialogContent>
            <Paper sx={{ padding: 2, marginBottom: 2 }} elevation={1}>
                <DialogContentText><div dangerouslySetInnerHTML={{ __html: requirement.name }}></div></DialogContentText>
            </Paper>
            <Attachements resourceId={requirement.guid} resourceType={BlobResourceType.UrsOfferRequirement} parentResourceId={ursGuid} parentResourceType={BlobResourceType.Document} canUpload={canUpload} canDelete={canDelete}/>
        </DialogContent>
        <DialogActions>
            <Button onClick={onClose}>
                <Localized id="close">Zamknij</Localized>
            </Button>
        </DialogActions>
    </Dialog>
}
